import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { BaseComponent } from './base.component';

@Component({
    selector: 'base-list-filter-atividade-capacitadora',
    template: `
    <form [formGroup]="filtro" novalidate>
        <div class="ui-g-14 ui-md-12 ui-lg-12 form-group">
            <form-text class="ui-g-12 ui-md-6 ui-lg-6" label="Pesquisar por membro da comissão" formControlName="membro_comissao"></form-text>
            <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Pesquisar por outros filtros" formControlName="query"></form-text>

        <div class="ui-g-12  ui-md-12"></div>
        </div>
    </form>
    <div class="ui-g-12 ui-md-4 ui-lg-3" style="margin-right: 6%;float: right;">
    <button pButton type="button" label="Consultar" (click)="consultar($event)" class="ui-button-madison"></button>
    </div>   
    `})
    
export class BaseListFilterAtividadeCapacitadoraComponent extends BaseComponent {
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;

    consultar(event: any) {
        const params = new URLSearchParams();
        const formValue = this.filtro.value;
        this.listagem.pDatatableComponent.first = 0;

        for (const key in formValue) {
            params.append(key, formValue[key]);
        }
        sessionStorage.setItem('funcionalidade',this.router.url.split('/')[2]);
        sessionStorage.setItem('filtro',params.toString());
        this.listagem.refresh();
      }
}


// WEBPACK FOOTER //
// ./src/app/base/base-list-filter-atividade-capacitadora.component.ts